var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,style:(_vm.styles),attrs:{"title":_vm.noOfLines && _vm.text},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n  "+_vm._s(_vm.bodyText)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }